import React from 'react';
import { RulesDefaultList } from './RulesList';

const Rules = () => {
    return (
        <>
            <RulesDefaultList />
        </>
    );
};

export default React.memo(Rules);
